/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Resetpassword1Inputs */

const en_entity_resetpassword1 = /** @type {(inputs: Entity_Resetpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset Password`)
};

const de_entity_resetpassword1 = /** @type {(inputs: Entity_Resetpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset Password" |
*
* @param {Entity_Resetpassword1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_resetpassword1 = /** @type {((inputs?: Entity_Resetpassword1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Resetpassword1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_resetpassword1(inputs)
	return de_entity_resetpassword1(inputs)
});
export { entity_resetpassword1 as "entity.resetPassword" }